module.exports = __webpack_public_path__ + "static/08-2-657f1b0f6b08ad13b810db34b7302ef3.jpg";